<div class="space-y-6">
  <!-- Accueil -->
  <div>
    <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">
      {{ greetingName() ? ('dashboard.bonjourName' | t: { name: greetingName() }) : ('dashboard.bonjour' | t) }}
    </h1>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ 'dashboard.voiciLEssentielDe' | t }}</p>
  </div>

  @if (error() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="error()"
      [loadingMessage]="'dashboard.chargementDuTableauDe' | t"
      (retry)="load()"
    />
  } @else if (vm(); as v) {
    <!-- Alertes -->
    @if (alerts().length > 0) {
      <div class="space-y-2">
        @for (a of alerts(); track a.text) {
          <a
            [routerLink]="a.link"
            class="flex items-center justify-between gap-3 rounded-lg border px-4 py-3 text-sm transition"
            [class.border-error-200]="a.tone === 'error'"
            [class.bg-error-50]="a.tone === 'error'"
            [class.text-error-700]="a.tone === 'error'"
            [class.hover:bg-error-100]="a.tone === 'error'"
            [class.dark:border-error-500/30]="a.tone === 'error'"
            [class.dark:bg-error-500/10]="a.tone === 'error'"
            [class.dark:text-error-400]="a.tone === 'error'"
            [class.border-warning-200]="a.tone === 'warning'"
            [class.bg-warning-50]="a.tone === 'warning'"
            [class.text-warning-700]="a.tone === 'warning'"
            [class.hover:bg-warning-100]="a.tone === 'warning'"
            [class.dark:border-warning-500/30]="a.tone === 'warning'"
            [class.dark:bg-warning-500/10]="a.tone === 'warning'"
            [class.dark:text-orange-400]="a.tone === 'warning'"
          >
            <span>{{ a.text }}</span>
            <span class="shrink-0 text-xs font-medium">{{ 'dashboard.voir' | t }}</span>
          </a>
        }
      </div>
    }

    <!-- KPI -->
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <!-- BALANCE retirable -->
      <a routerLink="/my-wallet" class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs transition hover:border-brand-300 dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-brand-500/40">
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'dashboard.soldeRetirable' | t }}</p>
        <p class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white/90">
          {{ v.wallet.withdrawableBalance | number:'1.0-0' }}
          <span class="text-sm font-normal text-gray-400">XOF</span>
        </p>
        @if (v.wallet.debt > 0) {
          <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ 'dashboard.creditDebt' | t }} : {{ v.wallet.debt | number:'1.0-0' }} XOF</p>
        } @else {
          <p class="mt-1 text-xs text-gray-400">CREDIT : {{ v.wallet.credit.balance | number:'1.0-0' }} XOF</p>
        }
      </a>

      <!-- Flotte -->
      <a routerLink="/my-vehicles" class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs transition hover:border-brand-300 dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-brand-500/40">
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'dashboard.mesVehicules' | t }}</p>
        <p class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white/90">{{ v.fleetTotal }}</p>
        <p class="mt-1 text-xs text-gray-400">
          {{ v.fleetAvailable }} {{ 'dashboard.available' | t }}
          @if (v.fleetUnderReview > 0) {
            · <span class="text-warning-600 dark:text-warning-400">{{ v.fleetUnderReview }} {{ 'dashboard.underReview' | t }}</span>
          }
        </p>
      </a>

      <!-- Locations actives -->
      <a routerLink="/my-rentals" class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs transition hover:border-brand-300 dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-brand-500/40">
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'dashboard.activeRentals' | t }}</p>
        <p class="mt-2 text-2xl font-semibold text-gray-800 dark:text-white/90">{{ v.activeRentalsCount }}</p>
        <p class="mt-1 text-xs text-gray-400">{{ 'dashboard.confirmeesOuEnCours' | t }}</p>
      </a>

      <!-- Factures en retard -->
      <a routerLink="/my-invoices" class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs transition hover:border-brand-300 dark:border-gray-800 dark:bg-white/[0.03] dark:hover:border-brand-500/40">
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'dashboard.overdueInvoices' | t }}</p>
        <p class="mt-2 text-2xl font-semibold"
           [class.text-error-700]="v.overdueCount > 0"
           [class.dark:text-error-400]="v.overdueCount > 0"
           [class.text-gray-800]="v.overdueCount === 0"
           [class.dark:text-white/90]="v.overdueCount === 0">
          {{ v.overdueCount }}
        </p>
        <p class="mt-1 text-xs text-gray-400">{{ 'dashboard.aReglerAuPlus' | t }}</p>
      </a>
    </div>

    <!-- Analytics (règlements + notes, slice 0) -->
    <app-owner-analytics />

    <!-- Analytics locations (funnel + réservations dans le temps) -->
    <app-rentals-analytics />

    <!-- Analytics parc (répartition par statut + acquisition) -->
    <app-vehicles-analytics />

    <!-- Analytics trésorerie (flux entrées/sorties/net) -->
    <app-wallet-analytics />

    <!-- Deux colonnes : locations actives + factures en retard -->
    <div class="grid gap-6 lg:grid-cols-2">
      <!-- Locations actives -->
      <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-center justify-between border-b border-gray-200 px-5 py-4 dark:border-gray-800">
          <h2 class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ 'dashboard.activeRentals' | t }}</h2>
          <a routerLink="/my-rentals" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">{{ 'common.seeAll' | t }}</a>
        </div>
        @if (v.activeRentals.length === 0) {
          <p class="px-5 py-8 text-center text-sm text-gray-400">{{ 'dashboard.aucuneLocationActivePour' | t }}</p>
        } @else {
          <ul class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (r of v.activeRentals; track r.id) {
              <li>
                <a [routerLink]="['/my-rentals', r.id]" class="flex items-center justify-between gap-4 px-5 py-3.5 transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                  <div class="min-w-0">
                    <p class="truncate text-sm font-medium text-gray-800 dark:text-white/90">{{ rentalVehicle(r) }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      {{ r.startDate | ldate: 'dd/MM/yy' }} → {{ r.endDate | ldate: 'dd/MM/yy' }}
                    </p>
                  </div>
                  <div class="flex shrink-0 items-center gap-3">
                    <span
                      class="inline-flex rounded-full px-2 py-0.5 text-xs font-medium"
                      [class.bg-brand-50]="rentalMeta[r.rentalStatusEnum].palette === 'brand'"
                      [class.text-brand-700]="rentalMeta[r.rentalStatusEnum].palette === 'brand'"
                      [class.dark:bg-brand-500/15]="rentalMeta[r.rentalStatusEnum].palette === 'brand'"
                      [class.dark:text-brand-400]="rentalMeta[r.rentalStatusEnum].palette === 'brand'"
                      [class.bg-blue-light-50]="rentalMeta[r.rentalStatusEnum].palette === 'blue-light'"
                      [class.text-blue-light-700]="rentalMeta[r.rentalStatusEnum].palette === 'blue-light'"
                      [class.dark:bg-blue-light-500/15]="rentalMeta[r.rentalStatusEnum].palette === 'blue-light'"
                      [class.dark:text-blue-light-400]="rentalMeta[r.rentalStatusEnum].palette === 'blue-light'"
                    >
                      {{ rentalMeta[r.rentalStatusEnum].label | t }}
                    </span>
                    <span class="whitespace-nowrap text-sm font-medium text-gray-800 dark:text-white/90">
                      {{ r.totalCost | number:'1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span>
                    </span>
                  </div>
                </a>
              </li>
            }
          </ul>
        }
      </section>

      <!-- Factures en retard -->
      <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-center justify-between border-b border-gray-200 px-5 py-4 dark:border-gray-800">
          <h2 class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ 'dashboard.overdueInvoices' | t }}</h2>
          <a routerLink="/my-invoices" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">{{ 'common.seeAll' | t }}</a>
        </div>
        @if (v.overdueInvoices.length === 0) {
          <p class="px-5 py-8 text-center text-sm text-gray-400">{{ 'dashboard.aucuneFactureEnRetard' | t }}</p>
        } @else {
          <ul class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (inv of v.overdueInvoices; track inv.id) {
              <li>
                <a [routerLink]="['/my-invoices', inv.id]" class="flex items-center justify-between gap-4 px-5 py-3.5 transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                  <div class="min-w-0">
                    <p class="truncate text-sm font-medium text-gray-800 dark:text-white/90">{{ inv.invoiceNumber }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      @if (inv.dueDate) { {{ 'dashboard.echeance' | t }} {{ inv.dueDate | ldate: 'dd/MM/yyyy' }} } @else { — }
                    </p>
                  </div>
                  <div class="flex shrink-0 items-center gap-3">
                    <span class="inline-flex rounded-full bg-error-50 px-2 py-0.5 text-xs font-medium text-error-700 dark:bg-error-500/15 dark:text-error-400">
                      {{ invoiceMeta[inv.status].label | t }}
                    </span>
                    <span class="whitespace-nowrap text-sm font-medium text-gray-800 dark:text-white/90">
                      {{ (inv.amountToCollect ?? inv.totalAmount ?? 0) | number:'1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span>
                    </span>
                  </div>
                </a>
              </li>
            }
          </ul>
        }
      </section>
    </div>

    <!-- Raccourcis -->
    <div class="flex flex-wrap gap-3">
      <a routerLink="/my-vehicles/new" class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-brand-600">
        {{ 'dashboard.ajouterUnVehicule' | t }}
      </a>
      <a routerLink="/my-wallet" class="inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
        {{ 'dashboard.myWallet' | t }}
      </a>
    </div>
  }
</div>
